<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
import { ModelSelect } from 'vue-search-select';
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
      ModelSelect
  },
  data() {
    return {
      errorMessage: "",
      title: "Create Ticket",
      items: [
        {
          text: "Support Ticket",
          href: "/",
        },
        {
          text: "Create",
          active: true,
        },
      ],
        subjects:[],
        admins:[],
        users:[],


      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
      errors: null,
        visible:false,
        message:"",
      form: {
          subject_id:"",
          user_id:"",
          message:"",
          message_file:"",
      },
      submitform: false,
      submitted: false,
    };
  },
  validations: {
    form: {
        subject_id: {
        required,
      },
        user_id: {
        required,
      },
        message: {
        required,
      },
    },
  },
    mounted() {
        this.getSubjectList();
        this.getAdminList();
    },
  methods: {
      onClose(){
          this.visible=false;
      },
      onFileChange(e) {
          this.form.message_filename =
              "Selected File: " + e.target.files[0].name;
          this.form.message_file = e.target.files[0];
      },
      async getAdminList() {
          try {
              axios
                  .get("/api/user/approved/list", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          let temp=response.data.data;
                          let i;
                          let arr=[];
                          for (i=0;i<temp.length;i++){
                              if(temp[i].account_type=='b2b' && temp[i].approved_agents[0]!=undefined){
                                  if(temp[i].approved_agents[0].approval_status=='approved') {
                                      temp[i].value = temp[i].id;
                                      temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                      arr.push(temp[i]);
                                  }
                              }
                              if(temp[i].account_type=='b2c'){
                                  temp[i].value = temp[i].id;
                                  temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                  arr.push(temp[i]);
                              }

                          }
                          this.users = arr;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      async getSubjectList() {
          try {
              axios
                  .get("/api/support-ticket/subject/list", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          this.subjects = response.data.data;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
        const config = {
            headers: {
                "content-type": "multipart/form-data",
                "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                    .content,
            },
        };
        var formData = this.gatherFormData();
      axios
          .post("/api/support-ticket/create", formData, config)
          .then((response) => {

              if (response.data.status) {
                  this.$refs.ticketCreateForm.reset();
                  this.$swal("Good job!", "Support Ticket Created", "success");
                  this.$router.push({ name: "support_ticket_list" });
              } else {
                  var str = response.data.message.message;
                  var jsonParse = JSON.parse(str);
                  this.errorCheck(jsonParse);
              }
          })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
      gatherFormData() {
          const data = new FormData();
          data.append("accessToken", localStorage.getItem("access_tocken"));
          data.append("subject_id", this.form.subject_id);
          data.append("user_id", this.form.user_id);
          data.append("message_file", this.form.message_file);
          data.append("message", this.form.message);
          return data;
      },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
            <b-form class="needs-validation" ref="ticketCreateForm" @submit.prevent="formSubmit">
              <div class="row">
                  <div class="col-md-4">
                      <div class="form-group">
                          <label class="required" for="subject_id">Select Subject</label>
                          <select
                              id="subject_id"
                              name="subject_id"
                              v-model="form.subject_id"
                              class="form-control"
                              placeholder="Type Select User"
                              :class="{ 'is-invalid': submitted && $v.form.subject_id.$error }">
                              <option value="" disabled style="display:none" selected>Select Subject</option>
                              <option v-for="(subject, index) in subjects" :value="subject.id"
                                      v-bind:key="index">{{ subject.name}}
                              </option>
                          </select>
                          <div
                              v-if="submitted && $v.form.user_id.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.user_id.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-4">
                      <div class="form-group">
                          <label class="required">Select User</label>
                          <model-select :options="users"
                                        v-model="form.user_id"
                                        :class="{ 'is-invalid': submitted && $v.form.user_id.$error }"
                                        placeholder="Select User">
                          </model-select>
<!--                          <select-->
<!--                              id="user_id"-->
<!--                              name="user_id"-->
<!--                              v-model="form.user_id"-->
<!--                              class="form-control"-->
<!--                              placeholder="Type Select User"-->
<!--                              :class="{ 'is-invalid': submitted && $v.form.user_id.$error }">-->
<!--                              <option value="" disabled style="display:none" selected>Select User</option>-->
<!--                              <option v-for="(user, index) in users" :value="user.id" v-if="user.account_type == 'b2b'"-->
<!--                                      v-bind:key="index">{{ user.first_name+' '+user.last_name }}-->
<!--                              </option>-->
<!--                          </select>-->
                          <div
                              v-if="submitted && $v.form.user_id.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.user_id.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-8">
                      <div class="form-group">
                          <label>File</label>
                          <div class="custom-file">
                              <input id="file" type="file" name="message_file" v-on:change="onFileChange($event)" class="custom-file-input" />
                              <label class="custom-file-label" for="file">File</label>
                          </div>
                      </div>
                  </div>
                <div class="col-md-8">
                  <div class="form-group">
                    <label class="required" for="message">Message</label>
                    <input
                      id="message"
                      v-model="form.message"
                      name="spt_message"
                      type="text"
                      class="form-control"
                      placeholder="Write Message"
                      value
                      :class="{ 'is-invalid': submitted && $v.form.message.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.message.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.message.required">This value is required.</span>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn btn-primary" type="submit">Submit</button>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
